export default "__VITE_ASSET__DQyUxHeR__"